import React from "react";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import TableComponent from "../../../common/TableComponent";
import { bohEquipment, cableEqipment, gasHandlingintakeEquipment, mleEquipment, MotorEquipment, protectorEquipment, pumpEquipment, sensorEquipment, separatorEquipment, surfaceEquipment } from "../../../../constants/columns/calculations/schematics";
import LABELS from "../../../../constants/labels/schematics.labels";

const EspEquipments: React.FC = () => {
    const { espEquipmentCollapse } = useAppSelector(
        (state) => state?.collapse
    );
    const { existedGasSepEquipments, existedGasHandlerEquipments, existedSRGasPump1Equipments, existedSRGasPump2Equipments, existedSRGasPump3Equipments } = useAppSelector(state => state?.gasCalculations);
    const pumpEspEquipments = useAppSelector(state => state?.pump.ESPEquipments)
    const updatedPumpEquipments = [...pumpEspEquipments?.filter((item: any) => Object.keys(item).length > 0), ...existedSRGasPump3Equipments, ...existedSRGasPump2Equipments, ...existedSRGasPump1Equipments];
    const updatedGasHandlerEquipments = [...existedGasHandlerEquipments];
    const { ESPEquipments, SelectedTransformer, HarmonicFilter } = useAppSelector(state => state?.surfaceEquipment);
    const { selectedWellEquipment, selectedWellLockEquipment } = useAppSelector(state => state?.cable);
    const { ESPEquipmentsBOH, } = useAppSelector(state => state?.pump);
    const { selectedLowerEquipment, selectedUpperEquipment } = useAppSelector(state => state?.protector);
    const { ESPEquipments: motorEspEquipments, ESPEquipmentsForSensor } = useAppSelector(state => state?.motor);
    const updatedGasSepEquipments = [...existedGasSepEquipments?.filter((item: any) => Object.keys(item).length > 0)];
    const motorPerformance = useAppSelector(
        (state) => state?.motor?.MotorperformanceList?.[0] ?? {}
    );
    const motorEquipmentColumns = MotorEquipment(motorPerformance);

    const { updateEspEquipmentCollapse } = useCollapseFacade();
    const handleCollapseChange = (key: boolean) => {
        updateEspEquipmentCollapse(key);
    };

    const handleSurfaceEquipmentData = () => {
        const hasData = ESPEquipments.length > 0 || SelectedTransformer || HarmonicFilter?.FilterSelection;

        if (!hasData) {
            return [];
        }
        const result = [...ESPEquipments];

        if (SelectedTransformer) {
            const transformerText = (SelectedTransformer?.equipmentName || SelectedTransformer?.transformers || '').replace(/(VOLTS.*)/, 'VOLTS');
            const pnMatch = (SelectedTransformer?.equipmentName || SelectedTransformer?.transformers || '').match(/PN\s*:\s*(\S+)/);
            const pnValue = pnMatch ? pnMatch[1] : SelectedTransformer?.pn;
            const oracleItemNumber = pnMatch ? parseInt(String(pnValue), 10) : SelectedTransformer?.pn;
            if (transformerText) {
                const updatedTransformer = {
                    ...SelectedTransformer,
                    text: transformerText.trim(),
                    oracle_Item_Number: oracleItemNumber,
                    pn: oracleItemNumber
                };
                result.push(updatedTransformer);
            }
        }

        if (Object?.keys(HarmonicFilter?.FilterSelection || {})?.length > 0) {
            const updatedHarmonicFilter: any = {
                ...HarmonicFilter.FilterSelection,
                text: HarmonicFilter?.FilterSelection?.name,
                oracle_Item_Number: HarmonicFilter?.FilterSelection?.harmPN,
                pn: HarmonicFilter?.FilterSelection?.harmPN
            };
            result?.push(updatedHarmonicFilter);
        }
        return result;
    };

    return (
        <Accordion
            title={LABELS?.espEquipments}
            isOpen={espEquipmentCollapse}
            onToggle={() => handleCollapseChange(!espEquipmentCollapse)}
            content={
                <div className="flex flex-col gap-[16px] p-4">
                    {handleSurfaceEquipmentData()?.length > 0 &&
                        (<TableComponent
                            overFlowClass="overflow-auto"
                            data={handleSurfaceEquipmentData() || []}
                            columns={[...surfaceEquipment]}
                            rowsPerPage={1}
                        />)
                    }
                    {
                        Array.isArray(selectedWellEquipment) && selectedWellEquipment.length > 0 &&
                        Object.keys(selectedWellEquipment[0] || {}).length > 0 && selectedWellEquipment[0]?.equipmentId !== "00000000-0000-0000-0000-000000000000" &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={selectedWellEquipment || []}
                            columns={[...cableEqipment]}
                            rowsPerPage={1}
                        />
                    }
                    {
                        Array.isArray(selectedWellLockEquipment) && selectedWellLockEquipment.length > 0 && Object.keys(selectedWellLockEquipment[0] || {}).length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={selectedWellLockEquipment || []}
                            columns={[...mleEquipment]}
                            rowsPerPage={1}
                        />
                    }

                    {
                        Array.isArray(ESPEquipmentsBOH) && ESPEquipmentsBOH.length > 0 && Object.keys(ESPEquipmentsBOH[0] || {}).length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={ESPEquipmentsBOH}
                            columns={[...bohEquipment]}
                            rowsPerPage={1}
                        />
                    }
                    {
                        Array.isArray(updatedPumpEquipments) && updatedPumpEquipments.length > 0 && Object.keys(updatedPumpEquipments[0] || {}).length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={updatedPumpEquipments}
                            columns={[...pumpEquipment]}
                            rowsPerPage={1}
                        />
                    }
                    {
                        updatedGasHandlerEquipments?.length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={existedGasHandlerEquipments}
                            columns={[...gasHandlingintakeEquipment]}
                            rowsPerPage={1}
                        />
                    }
                    {
                        updatedGasSepEquipments?.length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={updatedGasSepEquipments}
                            columns={[...separatorEquipment]}
                            rowsPerPage={1}
                        />
                    }
                    {/* Protectors */}
                    {(() => {
                        const hasUpperData = Array.isArray(selectedUpperEquipment) && selectedUpperEquipment.length > 0 && selectedUpperEquipment[0] && Object.values(selectedUpperEquipment[0]).length > 0;
                        const hasLowerData = Array.isArray(selectedLowerEquipment) && selectedLowerEquipment.length > 0 && selectedLowerEquipment[0] && Object.values(selectedLowerEquipment[0]).length > 0;
                        const validUpperEquipment = hasUpperData && selectedUpperEquipment[0]?.protectorID !== "00000000-0000-0000-0000-000000000000" ? selectedUpperEquipment : [];
                        const validLowerEquipment = hasLowerData && selectedLowerEquipment[0]?.protectorID !== "00000000-0000-0000-0000-000000000000" ? selectedLowerEquipment : [];
                        const combinedData = [...validUpperEquipment, ...validLowerEquipment];
                        return combinedData.length > 0 && (
                            <TableComponent
                                overFlowClass="overflow-auto"
                                data={combinedData}
                                columns={[...protectorEquipment]}
                                rowsPerPage={1}
                            />
                        );
                    })()}
                    {
                        motorEspEquipments && Array.isArray(motorEspEquipments) && motorEspEquipments.length > 0 && Object.keys(motorEspEquipments[0] || {}).length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={motorEspEquipments}
                            columns={[...motorEquipmentColumns]}
                            rowsPerPage={1}
                        />
                    }
                    {
                        ESPEquipmentsForSensor && Array.isArray(ESPEquipmentsForSensor) && ESPEquipmentsForSensor.length > 0 && Object.keys(ESPEquipmentsForSensor[0] || {}).length > 0 &&
                        <TableComponent
                            overFlowClass="overflow-auto"
                            data={ESPEquipmentsForSensor}
                            columns={[...sensorEquipment]}
                            rowsPerPage={1}
                        />
                    }
                </div>
            }
        />
    );
};

export default EspEquipments;
